// src/pages/Terms.js
import React from 'react';

function Terms() {
  return (
    <div className="terms-page" style={styles.container}>
      <h1 style={styles.title}>Terms & Conditions</h1>
      <p>
        Welcome to Kentech Phones. By accessing or using our web app and services, you agree to
        comply with and be bound by the following terms and conditions. If you do not agree with
        these terms, please do not use our services.
      </p>

      <h2 style={styles.subtitle}>1. Acceptance of Terms</h2>
      <p>
        By using our web app, you acknowledge that you have read, understood, and agree to be
        bound by these Terms & Conditions, as well as our Privacy Policy.
      </p>

      <h2 style={styles.subtitle}>2. Services</h2>
      <p>
        Kentech Phones provides repair and maintenance services for mobile devices, tablets,
        watches, gaming consoles, and other electronic devices. The details of each service, including pricing,
        warranty, and repair turnaround, will be communicated to you prior to service initiation.
      </p>

      <h2 style={styles.subtitle}>3. Booking and Payment</h2>
      <p>
        All repair services must be booked through our web app or via phone. Payment is required
        upon completion of the service unless otherwise agreed upon. Prices are subject to change
        based on parts availability and complexity.
      </p>

      <h2 style={styles.subtitle}>4. Warranty and Liability</h2>
      <p>
        We offer a standard 3-month warranty on repairs, excluding damages caused by misuse or
        accidents. Our liability for any loss or damage arising from our services is limited to
        the amount paid by you for the service.
      </p>

      <h2 style={styles.subtitle}>5. Intellectual Property</h2>
      <p>
        All content on this web app, including text, images, logos, and designs, is the property of
        Kentech Phones or its licensors. You may not reproduce, distribute, or create derivative
        works without our express written consent.
      </p>

      <h2 style={styles.subtitle}>6. User Obligations</h2>
      <p>
        You agree to provide accurate information when booking services and to update any changes
        promptly. You are responsible for maintaining the confidentiality of your account information,
        if applicable.
      </p>

      <h2 style={styles.subtitle}>7. Indemnification</h2>
      <p>
        You agree to indemnify and hold Kentech Phones harmless from any claims, damages, liabilities,
        or expenses arising from your use of our services or any violation of these Terms & Conditions.
      </p>

      <h2 style={styles.subtitle}>8. Governing Law and Jurisdiction</h2>
      <p>
        These Terms & Conditions shall be governed by and construed in accordance with the laws of the
        jurisdiction in which Kentech Phones operates. Any disputes arising from these terms shall be
        subject to the exclusive jurisdiction of the courts in that region.
      </p>

      <h2 style={styles.subtitle}>9. Changes to the Terms</h2>
      <p>
        We reserve the right to modify these Terms & Conditions at any time. The most current version
        will be posted on our web app. Your continued use of our services after any changes indicates
        your acceptance of the new terms.
      </p>

      <h2 style={styles.subtitle}>10. Contact Information</h2>
      <p>
        If you have any questions or concerns about these Terms & Conditions, please contact us at:
      </p>
      <ul style={styles.list}>
        <li style={styles.listItem}><strong>Email:</strong> support@kentechphonerepairs.co.uk</li>
        <li style={styles.listItem}><strong>Phone:</strong> 07944 859580</li>
        <li style={styles.listItem}><strong>Address:</strong> 24-25 New Rd, Gravesend DA11 0AA</li>
      </ul>
      <p>
        <em>Please note: These Terms & Conditions are provided for informational purposes only and do not constitute legal advice.</em>
      </p>
    </div>
  );
}

const styles = {
  container: {
    padding: '2rem',
    maxWidth: '800px',
    margin: '0 auto',
    fontFamily: 'SeoulBlack, sans-serif',
    color: '#6c757d',
    lineHeight: 1.6,
  },
  title: {
    textAlign: 'center',
    marginBottom: '1.5rem',
    color: '#007BFF',
  },
  subtitle: {
    marginTop: '2rem',
    marginBottom: '1rem',
    color: '#007BFF',
  },
  list: {
    listStyleType: 'disc',
    paddingLeft: '1.5rem',
  },
  listItem: {
    marginBottom: '1rem',
  },
};

export default Terms;
